import apiClient from '@/shared/services/apiClient';

/**
 * Smart Testing reporting client. Pulls aggregated WooCommerce smart-
 * testing order metrics for an organization. Used by the OHD employer
 * dashboard's Smart Testing card.
 */

export interface SmartTestingDailyPoint {
    day: string; // YYYY-MM-DD UTC
    sales_cents: number;
    labs_ordered: number;
    orders: number;
}

export interface SmartTestingMetrics {
    organization_id: number;
    window_start: string;
    window_end: string;
    orders: number;
    enrolled_participants: number;
    labs_ordered: number;
    total_sales_cents: number;
    daily_series: SmartTestingDailyPoint[];
}

export interface SmartTestCardMetric {
    key: string;
    display_name: string;
    assay_code: string | null;
    eligible_participants: number;
    completed_participants: number;
    gender_filter: 'm' | 'f' | null;
    placeholder: boolean;
    color: string;
}

export interface SmartTestCardsResponse {
    organization_id: number;
    campaign_id: number;
    cards: SmartTestCardMetric[];
}

export const SmartTestingReportingService = {
    async getMetrics(orgId: number, opts?: {startDate?: string; endDate?: string}): Promise<SmartTestingMetrics> {
        const params = new URLSearchParams({orgId: String(orgId)});
        if (opts?.startDate) params.set('startDate', opts.startDate);
        if (opts?.endDate) params.set('endDate', opts.endDate);
        return apiClient.get<SmartTestingMetrics>(`/api/admin/smart-testing/metrics?${params.toString()}`);
    },

    async getCards(orgId: number, campaignId: number): Promise<SmartTestCardsResponse> {
        return apiClient.get<SmartTestCardsResponse>(
            `/api/admin/smart-testing/cards?orgId=${orgId}&campaignId=${campaignId}`
        );
    },
};

export default SmartTestingReportingService;
